<app-page titolo="Utenti" [sottotitolo]="sottotitolo()">
  <button azioni type="button" mat-flat-button color="primary" (click)="new()">
    <mat-icon>add</mat-icon>
    Nuova persona
  </button>

  <div class="filtri">
    <mat-form-field class="filtri__ricerca">
      <mat-label>Cerca per nome o email</mat-label>
      <input matInput [formControl]="filtroTesto" autocomplete="off" />
      @if (filtroTesto.value) {
        <button type="button" matSuffix mat-icon-button aria-label="Svuota la ricerca" (click)="filtroTesto.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <div class="filtri__scelte filtri__scelte--aperte">
      <mat-form-field class="filtri__campo">
        <mat-label>Ruolo</mat-label>
        <mat-select [formControl]="filtroRuolo">
          <mat-option [value]="null">Tutti</mat-option>
          @for (ruolo of rolesDataSource; track ruolo.id) {
            <mat-option [value]="ruolo.id">{{ ruolo.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="filtri__stato">
        <mat-label>Stato</mat-label>
        <mat-select [formControl]="filtroAttivi">
          <mat-option [value]="null">Tutti</mat-option>
          <mat-option value="si">Attivi</mat-option>
          <mat-option value="no">Disattivati</mat-option>
        </mat-select>
      </mat-form-field>

      @if (filtriAttivi()) {
        <button type="button" mat-button (click)="azzeraFiltri()">Azzera filtri</button>
      }
    </div>
  </div>

  <app-data-table
    [columnDefinitions]="columnDefinitions"
    [pageSizeOptions]="[25, 50, 100]"
    [caricamento]="caricamento()"
    [errore]="errore()"
    [rigaCliccabile]="true"
    etichettaVuoto="Nessuna persona."
    (rigaScelta)="edit($event)"
    (pageChange)="search(true)"
    (pageSizeChange)="search()"
    (sortChange)="search()"
    (onInit)="search()"
  />
</app-page>

<ng-template #personaCella let-utente>
  <div class="autore">
    @if (utente.avatar) {
      <img class="autore__avatar" [src]="utente.avatar" [alt]="utente.blogger" />
    } @else {
      <span class="autore__iniziali" aria-hidden="true">{{ inizialiDi(utente) }}</span>
    }
    <div class="titolo-riga">
      <span class="titolo-riga__testo">{{ utente.blogger }}</span>
      <span class="titolo-riga__permalink">{{ utente.email }}</span>
    </div>
  </div>
</ng-template>

<ng-template #ruoloCella let-utente>
  @if (utente.role?.description) {
    <span class="etichetta-chip">{{ utente.role.description }}</span>
  }
</ng-template>

<ng-template #accessoCella let-utente>
  <span [matTooltip]="quandoPreciso(utente.last_login)">{{ quando(utente.last_login) }}</span>
</ng-template>

<ng-template #statoCella let-utente>
  <span class="stato" [class.stato--pubblicato]="utente.is_activated" [class.stato--bozza]="!utente.is_activated">
    {{ utente.is_activated ? 'Attivo' : 'Disattivato' }}
  </span>
</ng-template>

<ng-template #azioniCella let-utente>
  <button type="button" mat-icon-button aria-label="Modifica" (click)="$event.stopPropagation(); edit(utente)">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>

<ng-template #detailsModal>
  <h2 mat-dialog-title>{{ editItem?.id ? 'Modifica persona' : 'Nuova persona' }}</h2>

  <mat-dialog-content>
    <form class="modulo" [formGroup]="editItemForm">
      <div class="avatar-scelta">
        <div
          class="avatar-scelta__riquadro"
          [class.success]="uploadSuccess"
          [class.error]="uploadError"
          (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)"
        >
          <input type="file" accept="image/*" (change)="onFileChange($event)" hidden #fileInput />
          <button type="button" class="avatar-scelta__bersaglio" (click)="fileInput.click()">
            @if (imagePreview()) {
              <img [src]="imagePreview()" alt="Anteprima dell'avatar" />
            } @else {
              <mat-icon>add_a_photo</mat-icon>
            }
          </button>
        </div>
        <div class="avatar-scelta__testo">
          <p class="etichetta">Avatar</p>
          <p>{{ imageName() || 'Nessuna immagine' }}</p>
          @if (imagePreview()) {
            <button type="button" mat-button (click)="removeImage()">Togli</button>
          }
        </div>
      </div>

      <mat-form-field class="modulo__largo">
        <mat-label>Nome e cognome</mat-label>
        <input matInput formControlName="blogger" />
        <mat-hint>È la firma che compare sugli articoli.</mat-hint>
      </mat-form-field>

      <mat-form-field class="modulo__largo">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>

      <mat-form-field class="modulo__largo">
        <mat-label>Ruolo</mat-label>
        <mat-select formControlName="role" [compareWith]="utilsService.compareById">
          @for (ruolo of rolesDataSource; track ruolo.id) {
            <mat-option [value]="ruolo">{{ ruolo.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-checkbox formControlName="is_activated">Può entrare nel pannello</mat-checkbox>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (editItem?.id) {
      <button type="button" mat-button class="modulo__elimina" (click)="elimina()">Elimina</button>
    }
    <span class="modulo__spazio"></span>
    <button type="button" mat-button mat-dialog-close>Annulla</button>
    <button type="button" mat-flat-button color="primary" (click)="save()">Salva</button>
  </mat-dialog-actions>
</ng-template>
